'use client'
import { useState } from 'react'

import RoadViewHeader from '@/components/roadview/components/header/view'
import KakaoRoadview from '@/components/roadview/components/kakaoRoadview/view'

import Cover from '@/shared/components/Cover'

interface RoadViewProps {
  isRoadViewOpen: boolean
  setIsRoadViewOpen: React.Dispatch<React.SetStateAction<boolean>>
  latitude: number
  longitude: number
}

function RoadView({ isRoadViewOpen, setIsRoadViewOpen, latitude, longitude }: RoadViewProps) {
  const [isRoadviewFail, setIsRoadviewFail] = useState(false)
  return (
    <Cover id="layer2" zIndex={'z-200'} isOpen={isRoadViewOpen}>
      <div className="flex h-full w-full flex-col bg-010">
        <RoadViewHeader setIsRoadViewOpen={setIsRoadViewOpen} />
        {isRoadviewFail ? (
          <div className="z-[2] flex h-full w-full items-center justify-center whitespace-normal break-words bg-[#eee] text-center text-[24px]">
            ⚠️ 로드뷰가 제공되지 않는 지역입니다.
          </div>
        ) : (
          <KakaoRoadview latitude={latitude} longitude={longitude} setIsRoadviewFail={setIsRoadviewFail} />
        )}
      </div>
    </Cover>
  )
}

export default RoadView
